export default __webpack_public_path__ + "static/media/placeholder_store03-it-mobile.f36208db.png";